import { apiBaseURL } from '../ProjectConstants';

/*
 =-=-=-=-=- data structure -=-=-=-=-=

*/
async function handleDelBudget( fetch, operations, research, materials, billingCode ) {
    const body = {
        operationsBudget: operations.map((hour) => ({
            task: { id: hour.id },
            ProjectedHours: hour.ProjectedHours,
        })),
        researchBudget: research.map((hour) => ({
            task: { id: hour.id },
            ProjectedHours: hour.ProjectedHours,
        })),
        materialsBudget: materials.map(material => ({
            materialName: material.name,
            cost: material.cost,
        })),
        billingCode: billingCode,
    };

   const response = await fetch.delete(`${apiBaseURL}/api/budget?billingCode=${billingCode}`, body);
   const isDataGood = response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model';
    //const response = 'hi';
    console.log('handlePostBudget body', body);
    console.log('handlePutBudget response', response); 

    return {
        response,
        isDataGood
    };
}
export default handleDelBudget;